import "./style.css";
import { defineComponent as t, renderSlot as o } from "vue";
import { e as r } from "./index-KjzWfqlO.js";
const n = t({
  name: "awaiter",
  props: [],
  mounted() {
  }
});
function a(e, s, p, f, i, m) {
  return o(e.$slots, "default");
}
const u = /* @__PURE__ */ r(n, [["render", a]]);
export {
  u as default
};
